import { isYardzenHost } from "@yardzen/js-util";
import axios from "axios";
import Cookies from "js-cookie";
//Since this uses js-cookie, it can only be used in the browser when requiring an auth token.
//For SSR for authed requests, use server-base-client.ts

// Base URL for the API
const baseURL = process.env.NEXT_PUBLIC_BANYAN_REST_API_URL;

const authTokenCookieName = "yz_v2_token";

const apiClient = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Read the auth token from the cookie and add it to the request headers
apiClient.interceptors.request.use((config) => {
  const authToken = Cookies.get(authTokenCookieName);
  if (authToken) {
    config.headers["x-yz-auth-v2"] = authToken;
  }
  return config;
});

// Redirect 401 and 403 errors to the login page
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      if (typeof window !== "undefined") {
        // The v2 token is set with domain=.yardzen.com on staging/prod (see
        // V2AuthProvider); the remove must specify the same domain to match.
        const cookieDomain = isYardzenHost(window.location.hostname)
          ? ".yardzen.com"
          : undefined;
        Cookies.remove(authTokenCookieName, { domain: cookieDomain });
        // Never redirect if we're already on /login: doing so nests the
        // current URL into callbackUrl on every pass, growing it
        // exponentially until the proxy rejects the request.
        if (window.location.pathname !== "/login") {
          const currentPath = window.location.pathname + window.location.search;
          const loginUrl = `/login?callbackUrl=${encodeURIComponent(currentPath)}`;
          window.location.href = loginUrl;
        }
      }
    }
    return Promise.reject(error);
  },
);

export { apiClient };
